import BitmapTextWithCurrency from 'core/display/BitmapTextWithCurrency'
import { gsap } from 'gsap'
import { FormatService } from 'services/FormatService'
import { signal } from 'services/SignalsService'
import { time } from 'settings/custom/rolling'

export default class BitmapWinText extends PIXI.Container {
  constructor(data) {
    super()
    this.tween = { value: 0 }
    this.bitmapData = {}
    this.setBitmapData(data)
    this.bitmap = new BitmapTextWithCurrency(this.bitmapData)
    this.addChild(this.bitmap)

    signal.on('WIN-COLLECT', this.animate.bind(this))
    signal.on('WIN-COLLECT-GAMBLE', this.animateUpdate.bind(this))
    signal.on('ACTION:REQUEST-SPIN', this.reset.bind(this))
  }
  animate({ type, amount }) {
    const value = this.tween.value + amount
    const onUpdate = () => {
      const { numbers } = this.separateNumbers()
      this.bitmap.update(FormatService.currency(numbers, false))
    }
    const onComplete = () => {
      winTween.kill()
    }
    const winTween = gsap.to(this.tween, time[type], { value, onUpdate, onComplete })
  }
  animateUpdate({ type, amount }) {
    const value = amount
    const onUpdate = () => {
      const { numbers } = this.separateNumbers()
      this.bitmap.update(FormatService.currency(numbers, false))
    }
    const onComplete = () => {
      winTween.kill()
    }
    const winTween = gsap.to(this.tween, time[type], { value, onUpdate, onComplete })
  }
  onUpdate() {
    const { numbers } = this.separateNumbers()
    this.bitmap.update(FormatService.currency(numbers, false))
  }
  reset() {
    gsap.killTweensOf(this.tween)
    this.tween.value = 0
    this.onUpdate()
    this.bitmap.onReset()
  }
  separateNumbers() {
    const value = FormatService.currency(this.tween.value)
    const allNumbers = /\d/g
    const letters = FormatService.getCurrency()
    const numbers = value.match(allNumbers).join('')
    return { letters, numbers }
  }
  setBitmapData(data) {
    this.bitmapData = Object.assign({}, data)
    this.bitmapData.fontBitmap = 'bitmap'
    this.bitmapData.style.fontName = 'bitmap'
    const { letters } = this.separateNumbers()
    this.bitmapData.currency = letters
  }
}
